<template>
    <div class="checkout-summary-main" v-if="cart != null">
        <div :class="{ loadershow: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
            <img style="position:absolute;top:43%;left:40%;z-index:100" src="/assets/img/loader/loader.svg" />
        </div>
        <div v-if="cart.CartStatusTypes == 2" class="message-cart-status">
            <span>سفارش درحالت پرداخت می باشد امکان تغییر وجود ندارد حداکثر زمان لازم برای ویرایش 10دقیقه می باشد.</span>
        </div>
        <ul class="checkout-summary-summary">
            <li :class="[(cart.CartStatusTypes == 2) ? 'marginTop':'']">
                <span>تعداد محصول</span>
                <span>{{cart.CartInfo.CartDetailsCount}} عدد</span>
            </li>
            <!--   -----------------------------------------------   -->
            <li>
                <span>جمع قیمت محصولات</span>
                <span>{{ cart.CartInfo.SubTotalAmount | formatNumber }} ریال</span>
            </li>
            <!--   -----------------------------------------------   -->
            <li>
                <span>تخفیف</span>
                <span>{{cart.CartInfo.Discount  | formatNumber}} ریال</span>
            </li>
            <!--   -----------------------------------------------   -->
            <li v-if="cart.CartInfo.IsCouponDiscountApplied" class="ValueCupon">
                <span>مبلغ کد تخفیف</span>
                <span>{{cart.CartInfo.CouponDiscount | formatNumber}} ریال</span>

            </li>
            <!--   -----------------------------------------------   -->
            <li v-if="cart.CartInfo.TaxRate > 0 ">
                <span>مالیات برارزش افزوده ({{cart.CartInfo.TaxRate}}%) </span>
                <span>{{cart.CartInfo.Tax  | formatNumber}} ریال</span>
            </li>
            <!--   -----------------------------------------------   -->
            <li>
                <span>جمع قابل پرداخت چک </span>
                <span>{{cart.CartInfo.ChequePayableAmount  | formatNumber}} ریال</span>
            </li>
            <!--   -----------------------------------------------   -->
            <li>
                <span>جمع قابل پرداخت نقدی  </span>
                <span>{{cart.CartInfo.CashPayableAmount  | formatNumber}} ریال</span>
            </li>
            <li>
                <span>هزینه ارسال</span>
                <span v-if="!cart.CartInfo.IsAddressApplied">
                    وابسته به آدرس<span class="wiki wiki-holder">
                        <span class="wiki-sign"></span>
                        <div class="wiki-container js-dk-wiki is-right">
                            <div class="wiki-arrow"></div>
                            <p class="wiki-text">
                                هزینه ارسال سفارش نسبت به شهر و آدرس گیرنده متفاوت باشد.
                            </p>
                        </div>
                    </span>
                </span>
                <span v-if="cart.CartInfo.IsAddressApplied &&  cart.CartInfo.DeliveryFee != 0">{{cart.CartInfo.DeliveryFee | formatNumber }} ریال</span>
                <span v-if="cart.CartInfo.IsAddressApplied &&  cart.CartInfo.DeliveryFee == 0">رایگان</span>
            </li>
        </ul>
        <div class="checkout-summary-devider">
            <div></div>
        </div>
        <!--<div class="comment-content">
            <div class="text-comment">
                <textarea  type="text" v-model="comment"/>
            </div>
            <div class="btn-comment">
                <button @click="addComment" class="btn btn-info" style="width:100%">
                    افزودن توضیحات
                </button>
            </div>
        </div>-->

        <div class="checkout-summary-devider">
            <div></div>
        </div>
        <div class="checkout-summary-content">
            <div class="checkout-summary-price-title">مبلغ قابل پرداخت:</div>
            <div class="checkout-summary-price-value">
                <span class="checkout-summary-price-value-amount">{{cart.CartInfo.AmountPayable | formatNumber}}</span> ریال
            </div>
            <a @click="redirectToPage" class="selenium-next-step-shipping" v-if="baseInfo.MinimumOrders != 0 && baseInfo.MinimumOrders <= cart.CartInfo.SubTotalAmount">
                <div class="parent-btn">
                    <button class="dk-btn dk-btn-info">
                       ثبت نهایی در خواست خرید
                        <i class="now-ui-icons shopping_basket"></i>
                    </button>
                </div>
            </a>

            <a class="selenium-next-step-shipping" v-else>
                <div class="parent-btn">
                    <button disabled="disabled" style="cursor:not-allowed" class="dk-btn dk-btn2 dk-btn-info">
                        <span style="font-size:12px;">  حداقل مبلغ سفارش باید {{ baseInfo.MinimumOrders | formatNumber}} باشد  </span>
                    </button>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    import { getCart } from "../../module/cart";
    export default {
        data() {
            return {
                couponCode: '',
                redirectBtnName: '',
                comment: '',
                showLoader: false,
                isShowSppiner: false
            }
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
        methods: {
            setCouponToCart() {
                if (!IsNullOrEmptyString(this.couponCode)) {
                    this.isShowSppiner = true;
                    httpPromise(this, '/v1/Orders/CartCoupons/SetCouponToCart', 'post', { HashCartId: localStorage.getItem("CartHashId"), CouponCode: this.couponCode },
                        response => {
                            toastr.remove();
                            toastr.success(response.data.Message);
                            getCart(this, '');
                            this.isShowSppiner = false;
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowSppiner = false;
                        });
                } else {
                    toastr.remove();
                    toastr.error("کد تخفیف را وارد کنید.");
                }
            },
            deleteCoupon() {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Orders/CartCoupons/Delete', 'delete', { HashCartId: localStorage.getItem("CartHashId") },
                    response => {
                        toastr.remove();
                        toastr.success(response.data.Message);
                        getCart(this, '');
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    }
                );
            },
            redirectToPage() {
                httpPromise(this, '/v1/Orders/ColleagueOrders/Add', 'post', { HashCartId: localStorage.getItem("CartHashId"), UseCredit : false },
                    response => {
                        toastr.remove();
                        toastr.success(response.data.Message);
                        this.$router.push('/SuccessColleagueOrders');
                       // getCart(this, '');
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
                //switch (this.$route.path) {
                //    case '/chooseAddress':
                //        this.$router.push('/cart');
                //        break;
                //    case '/invoice':
                //        this.$router.push('/cart');
                //        break;
                //    case '/cart':
                //        this.$router.push('/chooseAddress');
                //        break;
                //}
            },
            //addComment() {
            //    toastr.remove();
            //    if (!IsNullOrEmptyString(this.comment)) {
            //        httpPromise(this, '/v1/Orders/Carts/AppendComment', 'post', JSON.stringify({ HashCartId: localStorage.getItem("CartHashId"), Comment: this.comment }),
            //            response => {
            //                toastr.success(response.data.Message);
            //                this.comment = '';
            //            },
            //            response => {
            //                toastr.error(response.data.Message);
            //                this.comment = '';
            //            });
            //    }
            //    else
            //        toastr.error('متن توضیحات نبایستی خالی باشد');

            //}
        },
        beforeMount: function () {
            if (this.$route.path == '/cart') {
                this.redirectBtnName = 'ادامه ثبت سفارش';
            }
            if (this.$route.path == '/chooseAddress') {
                this.redirectBtnName = 'ویرایش سفارش';
            }
            if (this.$route.path == '/invoice') {
                this.redirectBtnName = 'ویرایش سفارش';
            }

        }
    }
</script>

<style scoped>
    .checkout-summary-price-value-amount {
        font-size: 20px;
    }
    .checkout-summary-price-title {
        text-align: center;
        color: #676767;
        font-size: 18px;
    }
        .selenium-next-step-shipping .parent-btn .dk-btn {
        font-size: 18px;
        padding: 12px 80px;
    }
        .selenium-next-step-shipping .parent-btn .dk-btn::before {
            right: -11px;
            top: -11px;
        }
        .selenium-next-step-shipping .parent-btn .dk-btn > i {
            font-size: 23px;
            right: 12px;
            top: 11px;
        }
        .loadershow {
        display: none;
    }
    .marginTop {
        margin-top: 75px;
    }

    .message-cart-status {
        position: absolute;
        background-color: #ef5662;
        color: #fff;
        padding: 4px;
        text-align: center;
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
    }

    .checkout-summary-main {
        position: relative;
    }

    .comment-content {
        padding: 10px;
    }

        .comment-content .text-comment textarea {
            width: 100%;
            border-radius: 5px;
            border: 1px solid #ddd;
            padding: 10px;
            color: #555;
        }

        .comment-content .btn-comment {
            text-align: center;
        }

    .dk-btn2::before {
        width: unset;
    }

    .dk-btn2 {
        padding-right: 35px !important;
        background-color: #fb8282;
    }

    .wiki-holder:hover .wiki-container {
        display: block;
    }

    .checkout-summary-main {
        background-color: #fff;
    }

    .div-delete-copon {
        width: 100%;
        border: 1px solid #12b65c;
        border-radius: 5px;
        overflow: hidden;
        transition: all .3s;
        padding-left: 7px;
    }

        .div-delete-copon .text {
            display: inline-block;
            padding-right: 18px;
            height: 100%;
            display: inline-block;
            padding-right: 12px;
            height: 100%;
            padding-top: 12px;
        }

        .div-delete-copon .btn {
            float: left;
            font-weight: 400;
            font-size: 0.8571em;
            line-height: 1.35em;
            margin: 5px 6px;
            border: none;
            border-radius: 0.1875rem;
            padding: 9px 7px;
            cursor: pointer;
            background-color: #db6e6e;
            color: #FFFFFF;
            transition: all .3s;
        }

            .div-delete-copon .btn:hover {
                background-color: #e27575;
                transition: all .3s;
            }

    .div-add-copon {
        width: 100%;
        background-color: #fff;
        overflow: hidden;
    }

    .div-add-copon {
        width: 100%;
        border: 1px solid #12b65c;
        border-radius: 5px;
        overflow: hidden;
        transition: all .3s;
    }

        .div-add-copon:hover {
            border: 1px solid #3df433;
            transition: all .3s;
        }

        .div-add-copon .text {
            border: none;
            -webkit-box-shadow: none;
            box-shadow: none;
            padding-right: 10px;
            font-size: 14px !important;
            width: 70%;
            font-size: 12px;
            outline: 0;
            height: 100%;
        }

        .div-add-copon .btn {
            padding: 9px;
            float: left;
            font-weight: bold;
            border-right-color: currentcolor;
            border-right-style: none;
            border-right-width: medium;
            box-shadow: none;
            background-color: #2ec4b6;
            color: #fff;
            margin-left: 6px;
            transition: all .3s;
        }

            .div-add-copon .btn:hover {
                color: #fff;
                background-color: #38cec0;
                transition: all .3s;
            }
</style>